module.exports = __webpack_public_path__ + "static/media/chat_guide_en.0d7c7eaa.png";